<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t('user.change_password.title') }}</h2>

  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <mat-dialog-content class="flex flex-col gap-2">
      <mat-form-field class="w-full">
        <mat-label>{{ t('user.change_password.current_password') }}</mat-label>
        <input
          matInput
          formControlName="currentPassword"
          [type]="visible.currentPassword ? 'text' : 'password'"
          autocomplete="current-password"
        />
        <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="toggleVisible('currentPassword')">
          <mat-icon [svgIcon]="visible.currentPassword ? 'heroicons_solid:eye-slash' : 'heroicons_solid:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls.currentPassword.hasError('required')">
          {{ t('user.change_password.errors.current_required') }}
        </mat-error>
        <mat-error *ngIf="form.controls.currentPassword.hasError('invalidPassword')">
          {{ t('user.change_password.errors.current_invalid') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ t('user.change_password.new_password') }}</mat-label>
        <input
          matInput
          formControlName="password"
          required
          [type]="visible.password ? 'text' : 'password'"
          autocomplete="new-password"
        />
        <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="toggleVisible('password')">
          <mat-icon [svgIcon]="visible.password ? 'heroicons_solid:eye-slash' : 'heroicons_solid:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls.password.hasError('required')">
          {{ t('user.change_password.errors.new_required') }}
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('min_length')">
          {{ t('user.change_password.errors.min_length', { min: minLength }) }}
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('max_length')">
          {{ t('user.change_password.errors.max_length', { max: maxLength }) }}
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('same_as_current')">
          {{ t('user.change_password.errors.same_as_current') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ t('user.change_password.confirm_password') }}</mat-label>
        <input
          matInput
          formControlName="confirmPassword"
          required
          [type]="visible.confirmPassword ? 'text' : 'password'"
          autocomplete="new-password"
        />
        <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="toggleVisible('confirmPassword')">
          <mat-icon [svgIcon]="visible.confirmPassword ? 'heroicons_solid:eye-slash' : 'heroicons_solid:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls.confirmPassword.hasError('required')">
          {{ t('user.change_password.errors.confirm_required') }}
        </mat-error>
        <mat-error *ngIf="form.controls.confirmPassword.hasError('mismatch')">
          {{ t('user.change_password.errors.mismatch') }}
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" mat-dialog-close [disabled]="saving">{{ t('crud.cancel') }}</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="saving">
        <span class="flex items-center">
          <mat-spinner *ngIf="saving" diameter="18" class="mr-2"></mat-spinner>
          {{ t('user.change_password.submit') }}
        </span>
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
